export default __webpack_public_path__ + "static/media/product-7.66ef3637.webp";